import axios from "axios";
import PodBox from "pod-box-sdk";
import configs from "../configs";

export const API = axios.create({
  timeout: 50000,
  headers: {
    _token_issuer_: configs.TOKEN_ISSUER,
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const setInterceptors = () => {
  // Add a request interceptor
  API.interceptors.request.use(async function (config) {
    console.log(config.baseURL);
    const token = await PodBox.auth.getToken();
    return { ...config, headers: { ...config.headers, _token_: token, token } };
  });
};

export function get(Url, params) {
  return API.get(Url, { params });
}

export function post(Url, body, configs) {
  return API.post(Url, body, configs);
}
export function deleteMethod({ Url, body, params }) {
  return API.delete(Url, { data: body, params });
}
export function put(Url, body, params) {
  return API.put(Url, body, { params });
}

export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
}

export function getSubscriptionsList() {
  return axios
    .get(`${configs.POD_API_BASE_URL}timeline`, {
      params: {
        size: 10000,
        offset: 0,
        metadata: 'customPostType":"subscription  ',
        businessId: configs.BUSINESS_ID,
      },
    })
    .then((response) => response.data.result)
    .then((response) => response.map((item) => item.item))
    .then((response) =>
      response.map((item) => ({ ...item, ...JSON.parse(item.metadata) }))
    )
    .then((response) => ({ data: response }));
}

export const getBalance = () => {
  return post(`${configs.BOX_API_BASE_URL}balance`);
};

export const getSubscriptionInovice = (productId) => {
  return post(
    `${configs.BOX_API_BASE_URL}invoice`,
    {
      productId,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const batchInovice = (data) => {
  return post(`${configs.BOX_API_BASE_URL}batchInvoice`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
